(() => {
  if (customElements.get('scroll-step-slider')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ScrollStepSlider extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.step-slider-section__tab'));
      this.wrapper = this.querySelector('.step-slider-section__content-wrapper');
      this.blocks = Array.from(this.querySelectorAll('.step-slider-section__block'));
      if (!this.wrapper || this.blocks.length === 0) return;

      this.onTabClick = this.onTabClick.bind(this);
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));

      // Track the most visible block inside the scrollable wrapper.
      this.visibility = new Map();
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          this.updateActiveTab();
        },
        { root: this.wrapper, threshold: [0.25, 0.5, 0.75] }
      );
      this.blocks.forEach((block) => this.observer.observe(block));

      // Swipe between steps on touch devices.
      this.startX = 0;
      this.onTouchStart = (event) => {
        this.startX = event.touches[0].clientX;
      };
      this.onTouchEnd = (event) => {
        const diff = this.startX - event.changedTouches[0].clientX;
        const activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('active'));
        if (diff > 50 && activeIndex < this.blocks.length - 1) this.goToStep(activeIndex + 1);
        if (diff < -50 && activeIndex > 0) this.goToStep(activeIndex - 1);
      };
      this.wrapper.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.wrapper.addEventListener('touchend', this.onTouchEnd, { passive: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.wrapper) {
        this.wrapper.removeEventListener('touchstart', this.onTouchStart);
        this.wrapper.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    onTabClick(event) {
      const index = Number(event.currentTarget.getAttribute('data-step'));
      if (!Number.isNaN(index)) this.goToStep(index);
    }

    goToStep(index) {
      const target = this.blocks[index];
      if (!target) return;
      const top =
        target.getBoundingClientRect().top -
        this.wrapper.getBoundingClientRect().top +
        this.wrapper.scrollTop;
      this.wrapper.scrollTo({
        top,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
      this.setActiveTab(index);
    }

    updateActiveTab() {
      let bestIndex = -1;
      let bestRatio = 0;
      this.blocks.forEach((block, index) => {
        const ratio = this.visibility.get(block) || 0;
        if (ratio > bestRatio) {
          bestRatio = ratio;
          bestIndex = index;
        }
      });
      if (bestIndex >= 0) this.setActiveTab(bestIndex);
    }

    setActiveTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
        if (i === index) {
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('scroll-step-slider', ScrollStepSlider);
})();
